"use client"

import { usePartnerAccess } from "@/hooks/use-partner-access"

export function useProductChatAccess() {
  return usePartnerAccess("full_product_access")
}
